module.exports = __webpack_public_path__ + "static/img/index_ad_mys.115e39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/index_ad_mys.png
// module id = dd1n
// module chunks = 192